import { IUsefulLinks } from '@shared/models/main.interfaces';

const BASE_FOLDER = "assets/images/useful-links/";

export const USEFUL_LINKS: IUsefulLinks[] = [
    {
      link: 'http://www.policianacional.gob.do/',
      logo: BASE_FOLDER + 'POLICIAN.JPG',
      reference: 'PN'
    },
    {
      link: 'http://coopol.com.do/pag_index',
      logo: BASE_FOLDER + 'Coolpol.png',
      reference: 'Coopol'
    },
    {
      link: 'https://911.gob.do/',
      logo: BASE_FOLDER + '911-Republica-Dominicana-e1404306610558.jpg',
      reference: '911'
    },
    {
      link: 'http://www.policianacional.gob.do/transparencia/buzon-quejas-reclamaciones-y-sugerencias/',
      logo: BASE_FOLDER + 'sugerencias.png',
      reference: 'Sugerencias'
    },
    {
      link: 'https://spcc.pn.gob.do:8443/',
      logo: BASE_FOLDER + 'lupa.jpg',
      reference: 'SPCC'
    },
    {
      link: 'https://webmail.policia.gob.do/',
      logo: BASE_FOLDER + 'mail.png',
      reference: 'Webmail'
    },
    {
      link: 'https://www.arssenasa.gob.do/',
      logo: BASE_FOLDER + 'Logo-SeNaSa-Variantes_Horizontal.png',
      reference: 'Senasa'
    }
  ];
